import image from 'assets/image/snail-not_accept.png'
import { Link } from 'react-router-dom'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import css from './style.module.scss'

export const ModalIncludesTeam = () => (
	<article className={css.root}>
		<h2 className={`${css.title} ${typo.subtitle}`}>
			You dont have access to the team!
		</h2>

		<p className={`${css.lead} ${typo.largeButton}`}>
			Ask team owner to upgrade your subscription
		</p>
		<img
			alt='snail'
			className={css.image}
			height={154}
			src={image}
			width={190}
		/>
		<Button
			as={Link}
			className={css.link}
			to='/campaigns'
			typography={typo.largeButton}
		>
			Go home!
		</Button>
	</article>
)
